import { UserAvatar } from "@/components/ui/UserAvatar";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { formatDisplayName } from "@/lib/utils";

export interface TrainerDisplay {
  userId: string;
  firstName: string | null;
  lastNameInitial: string | null;
}

export interface TrainerCardContentProps {
  trainers: TrainerDisplay[];
}

export const TrainerCardContent = ({ trainers }: TrainerCardContentProps) => {
  return (
    <Card className="py-5 gap-4">
      <CardHeader className="pb-0">
        <CardTitle className="text-xs font-bold tracking-wide text-muted-foreground uppercase">
          Lernbegleiter
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        {/* Trainers */}
        {trainers.map((trainer, index) => {
          return (
            <div key={trainer.userId}>
              {index > 0 && <Separator className="mb-4" />}
              <div className="flex items-center gap-3">
                <UserAvatar
                  firstName={trainer.firstName ?? ""}
                  lastNameInitial={trainer.lastNameInitial ?? undefined}
                  colorIndex={index + 5}
                  size="md"
                />
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground">
                    {formatDisplayName(
                      trainer.firstName,
                      trainer.lastNameInitial
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
};
